__turbopack_context__.v({
  "actionButton": "ChartWidget-module__vroftW__actionButton",
  "actions": "ChartWidget-module__vroftW__actions",
  "badge": "ChartWidget-module__vroftW__badge",
  "badgeGreen": "ChartWidget-module__vroftW__badgeGreen",
  "container": "ChartWidget-module__vroftW__container",
  "description": "ChartWidget-module__vroftW__description",
  "header": "ChartWidget-module__vroftW__header",
  "headerExtra": "ChartWidget-module__vroftW__headerExtra",
  "headerText": "ChartWidget-module__vroftW__headerText",
  "menu": "ChartWidget-module__vroftW__menu",
  "menuBackdrop": "ChartWidget-module__vroftW__menuBackdrop",
  "menuItem": "ChartWidget-module__vroftW__menuItem",
  "menuWrapper": "ChartWidget-module__vroftW__menuWrapper",
  "title": "ChartWidget-module__vroftW__title",
});
